import React from 'react'
import styled from 'styled-components'
import { Text } from '~/components/core'
import { FontStyle } from '~/components/core/Text'
import { spacing } from '~/constants/theme'

const RootWrapper = styled.div`
  width: 100%;
  height: 20px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  margin-top: ${spacing.spacingLG};
`

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--chakra-colors-border-emphasized);
`

const DateWrapper = styled.div`
  padding: 0 20px;
  box-sizing: border-box;

  > p {
    white-space: nowrap;
    color: var(--chakra-colors-fg-subtle);
  }
`

interface MessageDateSplitterProps {
  date: string
}

const MessageDateSplitter = ({ date }: MessageDateSplitterProps) => {
  return (
    <RootWrapper>
      <Line />
      <DateWrapper>
        <Text fontStyle={FontStyle.ExTiny} text={date} />
      </DateWrapper>
      <Line />
    </RootWrapper>
  )
}

export default MessageDateSplitter
